import { Outlet } from 'react-router-dom';

import PageContainer from '~/shared/components/PageContainer';

import KPICards from './KPICards';
import NavTabs from './NavTabs';

export default function FleetManagerPage() {
  const tabs = [
    { label: 'AutoScale Rules', to: 'autoscale-rules' },
    { label: 'All Volumes', to: 'all-volumes' },
  ];

  return (
    <PageContainer className="px-6 pt-[18px] 4xl:pt-[30px] pb-4! min-w-[1120px] w-full flex-1!">
      <div>
        <KPICards />
      </div>

      <div className="mt-1.5 4xl:mt-3">
        <NavTabs items={tabs} className="" />
      </div>

      <div className="flex-1">
        <Outlet />
      </div>
    </PageContainer>
  );
}
